import { CommonModule, ViewportScroller } from '@angular/common';
import { NgModule } from '@angular/core';
import { DistancePipe } from '@smartcharge/shared/pipes/distance.pipe';

import { FormControlElementInjectorDirective } from './directives/form-control-element-injector.directive';
import { FormMarkTouchedDirective } from './directives/form-mark-all-as-touched.directive';
import { CurrencySymbolPipe } from './pipes/currency-symbol.pipe';
import { ParseIntPipe } from './pipes/parse-int.pipe';
import { PrettyJsonPipe } from './pipes/pretty-json.pipe';
import { StartCasePipe } from './pipes/start-case.pipe';
import { SmoothViewportScroller } from './services/smooth-viewport-scroller.service';

const DIRECTIVES = [FormControlElementInjectorDirective, FormMarkTouchedDirective];
const PIPES = [CurrencySymbolPipe, DistancePipe, ParseIntPipe, PrettyJsonPipe, StartCasePipe];

@NgModule({
  imports: [CommonModule],
  declarations: [...DIRECTIVES, ...PIPES],
  exports: [...DIRECTIVES, ...PIPES],
  providers: [
    {
      provide: Window,
      useValue: window
    },
    {
      provide: ViewportScroller,
      useClass: SmoothViewportScroller
    }
  ]
})
export class SharedModule {}
